<template>
  <div class="flex-column h-100">
    <div class="entity-info-header">
      <b-row>
        <b-col class="pr-0">
          <b-form-checkbox size="xl" class="select-all darkbg" v-model="selectAll" v-on:change="select($event)"></b-form-checkbox>
        </b-col>
        <b-col class="pl-2 pr-0">
          <component class="img-icon" :class="type" v-bind:is="type" v-b-tooltip.hover :title="type"></component> 
        </b-col>
        <b-col class="pt-1 pl-2">
          <div class="label">{{type}}&nbsp;({{entities.length}})</span></div>
        </b-col>
      </b-row>
      <div class="text-right position-relative">
        <b-input class="mb-2 mr-sm-2 mb-sm-0 search-input" id="search_text" v-model="search" type="text" placeholder="Search" />
        <div class="search-icon-container">
          <magnifier-icon class="icon-default search-icon"></magnifier-icon>
        </div>
      </div>
    </div>
    <div class="custom-tab-body-cont h-100">
      <update-item v-for="(entity) in entities" :key="entity.ID" :entity="entity" v-on:toggleGroup="toggleGroup" v-on:toggleSite="toggleSite"></update-item>
      <empty-placeholder v-if="entities.length===0" v-bind="placeholderProps"></empty-placeholder>
    </div>
    <div class="custom-tab-body-footer">
      <b-row>
        <b-col class="text-right">
          <label class="selected-label">{{selectedUpdatesCount}} selected</label>
          <span>
            <b-button v-if="!viewIgnore || viewIgnore == 'vulnerability'" variant="outline-secondary" @click="ignore()" :disabled="$v.selectedUpdates.$invalid">
              Ignore
              <spinner size="small" class="greybg" v-if="buttonLoaders.ignore"></spinner>
            </b-button>
            <b-button v-else variant="outline-secondary" @click="unIgnore()" :disabled="$v.selectedUpdates.$invalid">
              Un-Ignore
              <spinner size="small" class="greybg" v-if="buttonLoaders.unIgnore"></spinner>
            </b-button>
            <b-button variant="primary" class="ml-6" @click="update" :disabled="$v.selectedUpdates.$invalid">
              Update
              <spinner size="small" v-if="buttonLoaders.update"></spinner>
            </b-button>
          </span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import updateItem from './UpdateItem';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import EmptyPlaceholder from '../Common/EmptyPlaceholder';
import Plugins from '../../assets/plugins.svg';
import MagnifierIcon from '../../assets/lens.svg';
import Themes from '../../assets/themes.svg';
import Core from '../../assets/wordpress.svg';
import Translations from '../../assets/translation.svg';

export default {
  name: 'entityupdater',
  props: ['entities', 'type', 'buttonLoaders', 'viewIgnore'],
  components: {
    updateItem,
    Plugins,
    Core,
    Translations,
    Themes,
    MagnifierIcon,
    EmptyPlaceholder
  },
  data() {
    return {
      selectAll: false,
      currentTabIndex: 0,
      showUpdatePopup: false,
      placeholderProps: {
        text: () => {
          return `Looks like there are no ${this.type} updates.`;
        },
        type: 'positive'
      },
      search: ""
    };
  },
  mixins: [validationMixin],
  validations: {
    selectedUpdates: {
      required
    }
  },
  mounted(){
     this.$emit('update:searchtext', '');
     this.select(false);
  },
  watch:{
    search(updatedValue) {
      this.$emit('update:searchtext', updatedValue);
      // 
    },
    type(){
      this.selectAll = false;
      this.$emit('update:searchtext', '');
      this.select(false);
    },
    viewIgnore(){
      this.selectAll = false;
    }
  },
  computed: {
    selectedUpdates(updates) {
      let sites = [];
      _.each(this.entities, update => {
        let selectedSites = _.filter(update.sites, { selected: true });
        sites = _.concat(sites, selectedSites);
      });
      return sites;
    },
    selectedUpdatesCount() {
      return this.selectedUpdates.length;
    }
  },
  methods: {
    select(selectedValue) {
      this.$emit('selectAll', {
        type: this.type,
        value: selectedValue
      });
    },
    getSelectedUpdates(updates) {
      let sites = [];
      _.each(updates, update => {
        let selectedSites = _.filter(update.sites, { selected: true });
        sites = _.concat(sites, selectedSites);
      });
      return sites;
    },
    toggleGroup({ group, value }) {
      this.$store.commit({
        type: 'SELECT_GROUP_UPDATES',
        sites: group.sites,
        value: value
      });
      group.selected = value;
    },
    toggleSite({ group, site, isSelected }) {
      this.$store.commit({
        type: 'SELECT_SITE_UPDATE',
        site: site,
        value: isSelected
      });
    },
    update() {
      this.$emit('update', {
        value: this.getSelectedUpdates(this.entities)
      });
    },
    ignore() {
      this.$emit('ignore', {
        value: this.getSelectedUpdates(this.entities)
      });
    },
    unIgnore() {
      this.$emit('unIgnore', {
        value: this.getSelectedUpdates(this.entities)
      });
    },
  }
};
</script>

<style>
</style>
